<template>
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M39 57H52.5V45H39V57ZM19.5 57H33V45H19.5V57ZM15 27.6C15 27.351 15.039 27.15 15.078 27H24.429H33V39H15.078C15.039 38.85 15 38.649 15 38.4V27.6ZM21 18C21 16.344 22.539 15 24.429 15C28.2 15 30.51 18.27 31.782 21H24.429C22.539 21 21 19.656 21 18ZM47.571 15C49.461 15 51 16.344 51 18C51 19.656 49.461 21 47.571 21H40.2C41.46 18.27 43.764 15 47.571 15ZM57 27.6V38.4C57 38.649 56.961 38.85 56.922 39H39V27H47.571H56.922C56.961 27.15 57 27.351 57 27.6ZM57.6 21H56.421C56.775 20.058 57 19.059 57 18C57 13.038 52.77 9 47.571 9C41.805 9 38.187 12.597 36 16.191C33.813 12.597 30.195 9 24.429 9C19.23 9 15 13.038 15 18C15 19.059 15.228 20.058 15.579 21H14.4C11.373 21 9 23.901 9 27.6V38.4C9 41.721 10.92 44.379 13.5 44.892V57.999C13.5 60.756 15.939 63 18.936 63H53.061C56.061 63 58.5 60.756 58.5 57.999V44.892C61.08 44.379 63 41.721 63 38.4V27.6C63 23.901 60.627 21 57.6 21Z"
      fill="#231F20"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="9"
      y="9"
      width="54"
      height="54"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39 57H52.5V45H39V57ZM19.5 57H33V45H19.5V57ZM15 27.6C15 27.351 15.039 27.15 15.078 27H24.429H33V39H15.078C15.039 38.85 15 38.649 15 38.4V27.6ZM21 18C21 16.344 22.539 15 24.429 15C28.2 15 30.51 18.27 31.782 21H24.429C22.539 21 21 19.656 21 18ZM47.571 15C49.461 15 51 16.344 51 18C51 19.656 49.461 21 47.571 21H40.2C41.46 18.27 43.764 15 47.571 15ZM57 27.6V38.4C57 38.649 56.961 38.85 56.922 39H39V27H47.571H56.922C56.961 27.15 57 27.351 57 27.6ZM57.6 21H56.421C56.775 20.058 57 19.059 57 18C57 13.038 52.77 9 47.571 9C41.805 9 38.187 12.597 36 16.191C33.813 12.597 30.195 9 24.429 9C19.23 9 15 13.038 15 18C15 19.059 15.228 20.058 15.579 21H14.4C11.373 21 9 23.901 9 27.6V38.4C9 41.721 10.92 44.379 13.5 44.892V57.999C13.5 60.756 15.939 63 18.936 63H53.061C56.061 63 58.5 60.756 58.5 57.999V44.892C61.08 44.379 63 41.721 63 38.4V27.6C63 23.901 60.627 21 57.6 21Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <rect width="72" height="72" fill="#F08B71" />
    </g>
  </svg>
</template>
